import { Suspense } from 'react';
import { PreLoader } from './components/PreLoader/PreLoader';
import { AppProvider } from './context/AppContext';
import { AppRoutes } from './routes/AppRoute';
import { ToastContainer } from 'react-toastify';
import { AuthProvider } from './context/AuthContext';
import { ThemeProvider } from "styled-components";
import { theme } from './theme';
import { ModalProvider } from './context/ModalContext';
const App = () => {
  return (
    <Suspense fallback={<PreLoader show={true}/>}>
      <ThemeProvider theme={theme}>
        <AppProvider>
            <AuthProvider>
              <AppRoutes />
              <ToastContainer />
            </AuthProvider>
        </AppProvider>
      </ThemeProvider>
    </Suspense>
  );
}

export default App;
